module.exports = __webpack_public_path__ + "img/topLogoC2.7f2c077d.png";